import React, { useContext } from "react";
import navMenuData from "./NavMenuData";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Button } from "../Button/Button";
import { IoIosArrowBack } from "react-icons/io";
import { AppContext } from "../AppProvider/AppProvider";
import { Container } from "../Container/Container";

const NavMenuWrapper = styled.div`
  background-color: var(--min-color);
  position: absolute;
  height: 100%;
  width: 100%;
  top: -150%;
  left: 0;
  transition-delay: 250ms;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.1, 0.2, 0.3, 1.4);
  z-index: 99;

  .brand {
    opacity: 0;
  }

  &.active {
    top: 0;
    transition-delay: 250ms;
    transition-duration: 0.3s;

    .brand {
      opacity: 1;
      transition-delay: 600ms;
    }

    .list--items {
      .item--link {
        opacity: 1;
        transform: scale(1);
        transition-delay: 600ms;
        &:nth-child(2) {
          transition-delay: 650ms;
        }
        &:nth-child(3) {
          transition-delay: 700ms;
        }
        &:nth-child(4) {
          transition-delay: 800ms;
        }
        &:nth-child(5) {
          transition-delay: 850ms;
        }
        &:nth-child(6) {
          transition-delay: 900ms;
        }
        &:nth-child(7) {
          transition-delay: 950ms;
        }
      }
    }
  }
`;

const ListWraper = styled.div``;
const ItemLink = styled(Link)`
  opacity: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  transform: scale(0.7);
  transition-delay: 0.55s;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.1, 0.2, 0.3, 1.4);

  .button {
    font-weight: bold;
    padding: 20px 15px;
  }
`;

function NavMenu() {
  const [isOpen, setIsOpen] = useContext(AppContext);

  let activeClass;
  isOpen ? (activeClass = "active") : (activeClass = "");

  return (
    <NavMenuWrapper className={activeClass}>
      <Container>
        <ListWraper className="list--items">
          {navMenuData.List.map((item, index) => (
            <ItemLink
              key={index}
              className="item--link"
              to={item.path}
              onClick={() => setIsOpen(!isOpen)}
            >
              <Button btnSize="btn--full-width" btnStyle="btn--hovered">
                {item.name}
                <IoIosArrowBack />
              </Button>
            </ItemLink>
          ))}
        </ListWraper>
      </Container>
    </NavMenuWrapper>
  );
}

export default NavMenu;
